<template>
  <div>
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      size="mini"
    >
      <el-form-item label="用户名/手机号">
        <el-input v-model="searchForm.keyword" clearable></el-input>
      </el-form-item>
      <el-form-item label="权益卡">
        <el-select
          v-model="searchForm.cardType"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in cardTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="激活时间">
        <el-date-picker
          v-model="searchForm.beginTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="searchForm.status"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-form-item>
          <el-button type="primary" @click="loadPage(1)">查询</el-button>
        </el-form-item>
      </el-form-item>
    </el-form>

    <!--buttons-->
    <div style="margin-bottom: 10px" class="table-btns">
      <div class="rl">
        <el-button size="mini" @click="handleRecycling">回收权益</el-button>
      </div>
      <div class="rl">
        <el-button size="mini" @click="downLoad.exportExcel('tableId')"
          >导出</el-button
        >
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
      id="tableId"
    >
      <el-table-column label="用户信息" align="center">
        <template slot-scope="scope">
          <span
            >{{ scope.row.subscriberName }} /
            {{ scope.row.subscriberPhone }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="privilegeCardName"
        label="权益卡名称"
      ></el-table-column>
      <el-table-column prop="cardTypeName" label="权益卡类型" align="center">
      </el-table-column>
      <el-table-column prop="cardStatusName" label="权益卡状态" align="center">
      </el-table-column>
      <el-table-column prop="originName" label="权益卡来源" align="center">
      </el-table-column>
      <el-table-column prop="originValue" label="权益卡来源值" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.origin == 1"
            type="primary"
            :underline="false"
            size="mini"
            @click="gogoOrderDetail(scope.row)"
            >{{ scope.row.originValue }}
          </el-link>
          <span v-else>{{ scope.row.originValue }}</span>
        </template>
      </el-table-column>
      <el-table-column label="有效期" align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.startTime || "--" }} ~
            {{ scope.row.endTime || "--" }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="payPrice" label="购买金额" align="center">
      </el-table-column>
      <el-table-column prop="adminStatusName" label="工单状态" align="center">
      </el-table-column>
      <el-table-column prop="engineerName" label="工程师" align="center">
      </el-table-column>
      <el-table-column prop="actualPrice" label="实付金额" align="center">
      </el-table-column>
      <el-table-column prop="created" label="创建时间" align="center">
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>

    <privilege-recycling
      ref="recyclingRef"
      @refresh="loadPage"
    ></privilege-recycling>
  </div>
</template>
<script>
import { privilegeCardTypeApi, privilegeCardStatusApi } from "@/api/privilege";
import { queryPrivilegeCardPageApi } from "@/api/subscriber";
import PrivilegeRecycling from "./components/recycling.vue";
export default {
  name: "SubscriberPrivilege",
  components: {
    PrivilegeRecycling
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 权益卡类型
      cardTypeOptions: [],
      // 权益卡状态
      statusOptions: [],
      tableData: [],
      loading: false
    };
  },
  created() {
    this.getPrivilegeCardTypeOptions();
    this.getPrivilegeCardStatusOptions();
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    getPrivilegeCardTypeOptions() {
      let _self = this;
      privilegeCardTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.cardTypeOptions = resp.data.results;
        }
      });
    },
    getPrivilegeCardStatusOptions() {
      let _self = this;
      privilegeCardStatusApi().then(resp => {
        if (resp.data.status == 100) {
          _self.statusOptions = resp.data.results;
        }
      });
    },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      queryPrivilegeCardPageApi(this.searchForm)
        .then(res => {
          this.loading = false;
          if (res.data.status == 100) {
            this.tableData = res.data.results.list;
            this.searchForm.total = res.data.results.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    handleRecycling() {
      this.$refs.recyclingRef.open();
    },
    gogoOrderDetail(row) {
      this.$router.push({
        path: "/visitRepair",
        query: { orderId: row.orderId, orderNo: row.originValue }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table-btns {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .rl {
    display: flex;
    align-items: center;
  }
  .btn {
    margin-left: 10px;
  }
  .rl {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?2c29abaf